import { render, staticRenderFns } from "./RelatorioOSPage.vue?vue&type=template&id=798d89f0&scoped=true"
import script from "./RelatorioOSPage.vue?vue&type=script&lang=js"
export * from "./RelatorioOSPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798d89f0",
  null
  
)

export default component.exports